import React from "react";
import { connect } from "react-redux";

import {
  Pagination as BootstrapPagination,
  PaginationLink,
  PaginationItem
} from "reactstrap";

class Pagination extends React.Component {
  constructor() {
    super();
  }

  render() {
    const { numberOfPages, currentPage, setPage } = this.props;
    let { maxPagesDisplay } = this.props;

    let withDots = true;
    if (maxPagesDisplay >= numberOfPages) {
      withDots = false;
    }
    if (maxPagesDisplay > numberOfPages) {
      maxPagesDisplay = numberOfPages;
    }

    let items = [];

    let i = currentPage - parseInt(maxPagesDisplay / 2) < 1
      ? 1
      : currentPage + parseInt(maxPagesDisplay / 2) > numberOfPages
          ? numberOfPages - maxPagesDisplay + 1
          : currentPage - parseInt(maxPagesDisplay / 2);

    const limit = i + maxPagesDisplay;

    for (i; i < limit; i++) {
      items.push(
        <PaginationItem
          key={i}
          active={i === currentPage}
          onClick={setPage.bind(this, i)}
        >
          <PaginationLink>
            {i}
          </PaginationLink>
        </PaginationItem>
      );
    }

    const first = withDots
      ? maxPagesDisplay > numberOfPages
          ? null
          : currentPage - parseInt(maxPagesDisplay / 2) > 1
              ? <PaginationItem
                  active={1 === currentPage}
                  onClick={setPage.bind(this, 1)}
                >
                  <PaginationLink>
                    {1}
                  </PaginationLink>
                </PaginationItem>
              : null
      : null;
    const last = withDots
      ? maxPagesDisplay > numberOfPages
          ? null
          : currentPage < numberOfPages - parseInt(maxPagesDisplay / 2)
              ? <PaginationItem
                  active={numberOfPages === currentPage}
                  onClick={setPage.bind(this, numberOfPages)}
                >
                  <PaginationLink>
                    {numberOfPages}
                  </PaginationLink>
                </PaginationItem>
              : null
      : null;

    if (first !== null) {
      items.shift();
    }

    if (last !== null) {
      items.pop();
    }

    const prev = (
      <PaginationItem
        disabled={currentPage === 1}
        onClick={currentPage !== 1 ? setPage.bind(this, currentPage - 1) : null}
      >
        <PaginationLink>
          <i className="fa fa-angle-left" />
        </PaginationLink>
      </PaginationItem>
    );

    const next = (
      <PaginationItem
        disabled={currentPage === numberOfPages}
        onClick={
          currentPage !== numberOfPages
            ? setPage.bind(this, currentPage + 1)
            : null
        }
      >
        <PaginationLink>
          <i className="fa fa-angle-right" />
        </PaginationLink>
      </PaginationItem>
    );

    if (numberOfPages > 1) {
      return (
        <BootstrapPagination>
          {prev}
          {first}
          {first !== null
            ? <PaginationItem disabled>
                <PaginationLink>
                  ...
                </PaginationLink>
              </PaginationItem>
            : null}
          {items}
          {last !== null
            ? <PaginationItem disabled>
                <PaginationLink>
                  ...
                </PaginationLink>
              </PaginationItem>
            : null}
          {last}
          {next}
        </BootstrapPagination>
      );
    } else {
      return <div />;
    }
  }
}

export default connect(state => ({}), {})(Pagination);



// WEBPACK FOOTER //
// ./src/browser/components/Pagination/Pagination.js